var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"h-4 w-4",class:_vm.getCustomClass,style:(_vm.getStyle)}),_c('label',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }